import { Box, MenuItem, Select, Typography, Button } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useState } from 'react';
import dayjs from 'dayjs';

type PeriodFilterProps = {
  years: number[];
  year?: number;
  onApplyFilter: (selectedYear: number) => void
}

const periodOptions = [
  { value: '30', label: 'Últimos 30 dias' },
  { value: '60', label: 'Últimos 60 dias' },
  { value: '90', label: 'Últimos 90 dias' },
  { value: 'year', label: 'Ano Atual' },
];

const PeriodFilter: React.FC<PeriodFilterProps> = ({ years, year, onApplyFilter }) => {
  const [selectedYear, setSelectedYear] = useState<number | null>(year);
  const [selectedPeriod, setSelectedPeriod] = useState('');
  const [customStartDate, setCustomStartDate] = useState();
  const [customEndDate, setCustomEndDate] = useState();

  const handlePeriodChange = (event) => {
    const period = event.target.value;
    setSelectedPeriod(period);

    let newStartDate, newEndDate;
    if (period === 'year') {
      newStartDate = dayjs().startOf('year').format('YYYY-MM-DD');
      newEndDate = dayjs().endOf('year').format('YYYY-MM-DD');
    } else if (period) {
      const days = parseInt(period, 10);
      newStartDate = dayjs().subtract(days, 'day').format('YYYY-MM-DD');
      newEndDate = dayjs().format('YYYY-MM-DD');
    }

    if (newStartDate && newEndDate) {
      // onStartDateChange(newStartDate);
      // onEndDateChange(newEndDate);
      setCustomStartDate(newStartDate);
      setCustomEndDate(newEndDate);
    }
  };


  const applyFilter = () => {
    onApplyFilter(selectedYear)
  }

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: '#fff',
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'end',
        p: '8px',
        '.MuiInputBase-input': { padding: '5px', color: '#000' },
        '.MuiButtonBase-root': { color: '#000' },
        '.MuiTypography-root': { color: '#000' },
      })}
    >
     <Box sx={{ maxWidth: '260px', width: '100%'}}>
        <FormControl sx={{ '.MuiSvgIcon-root': { color: 'rgba(68, 68, 68, 1)' } }} fullWidth>
          <Typography mb={'7px'}>Ano*</Typography>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            sx={{ color: '#000' }}
            value={selectedYear}
            onChange={event => setSelectedYear(Number(event.target.value))}
          >
            {years?.map((year) => <MenuItem value={year}>{year}</MenuItem>)}
          </Select>
        </FormControl>
      </Box>

       <DemoItem sx={{ maxWidth: '260px', width: '100%'}}>
        <Typography>Mês*</Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={['month']}
          />
        </LocalizationProvider>
      </DemoItem>

       <DemoItem sx={{ maxWidth: '260px', width: '100%'}}>
        <Typography>Período*</Typography>
        <FormControl fullWidth margin="normal">
          <Select
            labelId="period-select-label"
            value={selectedPeriod}
            onChange={handlePeriodChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">
              <em>Selecione um período</em>
            </MenuItem>
            {periodOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DemoItem>

      <Button
        sx={{
          maxWidth: '80px',
          p: '0 5px',
          borderRadius: '24px',
          fontSize: '14px',
          height: '37px',
          color: '#fff !important',
          width: '188px',
          fontWeight: '600',
          textTransform: 'none',
          backgroundColor: '#15AB51'
        }}
        variant="contained"
        onClick={applyFilter}
      >
        Buscar
      </Button>
    </Box>
  );
};

export default PeriodFilter;